const PALETTE = [
  { color: '#0d9488', soft: '#ccfbf1', ink: '#134e4a' },
  { color: '#d97706', soft: '#fef3c7', ink: '#78350f' },
  { color: '#7c3aed', soft: '#ede9fe', ink: '#3b0764' },
  { color: '#2563eb', soft: '#dbeafe', ink: '#1e3a8a' },
  { color: '#db2777', soft: '#fce7f3', ink: '#831843' },
  { color: '#059669', soft: '#d1fae5', ink: '#064e3b' },
  { color: '#ea580c', soft: '#ffedd5', ink: '#7c2d12' },
  { color: '#0891b2', soft: '#cffafe', ink: '#164e63' },
] as const;

export type ObjectColors = (typeof PALETTE)[number];

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

// Pass objectName today; swap to objectId once the backend exposes it
// (see docs/PLANNING_BACKEND_CHANGES.md).
export function getObjectColors(key: string | null | undefined): ObjectColors {
  if (!key) return PALETTE[7];
  return PALETTE[hash(key) % PALETTE.length];
}
